// react
import { Suspense } from 'react';

// tanstack
import { createFileRoute, Navigate, Outlet } from '@tanstack/react-router';

// shared components
import { ServiceGuard } from '@/components/access-control/ServiceGuard';

// feature-components
import EnergyAnalysisAppBar from '@/features/energyxplorer/components/EnergyAnalysisAppBar';

export const Route = createFileRoute(
  '/$accountId/_user/energyxplorer/portfolio',
)({
  component: () => (
    <ServiceGuard
      serviceNames={['PortfolioAnalysis']}
      fallback={<Navigate to="/$accountId" />}
    >
      <Suspense>
        <EnergyAnalysisAppBar />
      </Suspense>
      <Suspense>
        <Outlet />
      </Suspense>
    </ServiceGuard>
  ),
  staticData: { crumb: 'glossary:portfolio', hideEnergyAnalysisAppBar: true },
});
